import React from "react";
import { motion } from "framer-motion";

const placeholder = new URL(
  "../../../../assets/placeholder.png",
  import.meta.url,
).href;

export default function ProduktCard({ item, onClick, onAddToCart, delay = 0 }) {
  if (!item) return null;

  return (
    <motion.article
      onClick={() => onClick(item.idProdukt, item.Kategorie)}
      className="
        kn-page group w-full max-w-sm cursor-pointer
        bg-white border border-knapp-border rounded-[14px] p-5
        transition-shadow duration-150
        hover:shadow-[0_6px_20px_rgba(21,16,15,0.08)]
      "
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay, duration: 0.5, ease: "easeOut" }}
    >
      {/* Bild */}
      <div className="relative mx-auto w-3/4 aspect-square rounded-[10px] overflow-hidden flex items-center justify-center">
        <img
          src={item.Bild || placeholder}
          alt={item.Name}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = placeholder;
          }}
          className="object-contain w-full h-full"
        />
      </div>

      {/* Inhalt */}
      <h3 className="mt-3.5 text-base font-semibold leading-tight text-knapp-ink">
        {item.Name}
      </h3>

      <div className="mt-3 flex items-center justify-between flex-wrap gap-2.5">
        <div className="text-lg font-bold text-knapp-accent">
          CHF {Number(item.Preis_brutto).toFixed(2)}
        </div>
        <button
          onClick={(e) => {
            e.stopPropagation();
            onAddToCart();
          }}
          className="kn-btn-primary text-[13px] py-2.5 px-4"
        >
          Zum Warenkorb hinzufügen
        </button>
      </div>
    </motion.article>
  );
}
